import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { http, resolveImage } from "@/lib/api";
import Layout from "@/components/Layout";
import { PageHero } from "@/hooks/usePageContent";
import { ArrowRight } from "lucide-react";

export default function Stories() {
  const [arts, setArts] = useState([]);
  useEffect(() => {
    http.get("/artworks").then(({ data }) => setArts(data));
  }, []);

  return (
    <Layout>
      <PageHero slug="stories" />
      <section className="bg-[#050505] pt-16 pb-12">
        <div className="max-w-[1280px] mx-auto px-6 lg:px-10 text-center">
          <div className="font-ui text-[11px] tracking-[0.32em] text-[#C9A055] mb-3">The Stories</div>
          <h1 className="font-display text-5xl md:text-7xl text-[#F4F1EA] leading-[0.95] mb-4">EVERY PIECE.<br/>EVERY STORY.</h1>
          <p className="font-script text-[#C9A055] text-2xl md:text-3xl">The truths behind the art.</p>
        </div>
      </section>
      <section className="bg-[#050505] pb-24">
        <div className="max-w-[1280px] mx-auto px-6 lg:px-10 space-y-10">
          {arts.map((a, i) => (
            <Link key={a.id} to={`/artwork/${a.slug}`} className="grid md:grid-cols-12 gap-8 border-t border-white/10 pt-10 group">
              <div className="md:col-span-4">
                <div className="relative aspect-square overflow-hidden border border-white/10">
                  <img src={resolveImage(a.main_image)} alt={a.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
                  {a.collection_number && (
                    <div className="absolute top-3 right-3 px-2 py-0.5 border border-[#C9A055] bg-black/50 text-[#C9A055] font-ui text-[10px] tracking-[0.2em]">#{String(a.collection_number).padStart(2,"0")}</div>
                  )}
                </div>
              </div>
              <div className="md:col-span-8">
                <div className="font-ui text-[10px] tracking-[0.32em] text-[#C9A055] mb-2">Truth #{i + 1}</div>
                <h2 className="font-display text-3xl md:text-5xl text-[#F4F1EA] mb-3">{a.title.toUpperCase()}</h2>
                <p className="font-script text-[#C9A055] text-2xl mb-4">{a.short_description}</p>
                <p className="font-body text-[#B5B0A7] leading-relaxed line-clamp-3 mb-4">{a.story}</p>
                <span className="font-ui text-[10px] tracking-[0.32em] text-[#C9A055] inline-flex items-center gap-2 group-hover:gap-3 transition-all">Read the Story <ArrowRight size={13}/></span>
              </div>
            </Link>
          ))}
        </div>
      </section>
    </Layout>
  );
}
